// extracted by mini-css-extract-plugin
export default {"ResumePage":"Resume_ResumePage__KGCUK","sectionHead":"Resume_sectionHead__YTLnQ"};